import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import HeaderNotificationComponent from "../pages/notification/HeaderNotificationComponent";
import HeaderMessageComponent from "../components/HeaderMessageComponent";
import { rolePermissions } from "../utils/rolePermissions";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getEventLocations } from "../redux/eventLocation/eventLocationSlice";
import { useLocationFilter } from "../context/LocationContext";
import { getLoggedInUserInfo } from "../redux/auth/authApi";
import Avatar from "../components/Avtar/Avatar";

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const loggedInUserInfo = getLoggedInUserInfo();

  const dispatch = useDispatch();
  const { locations = [] } = useSelector((state) => state.eventLocation);
  const { selectedLocation, setSelectedLocation } = useLocationFilter();
  const isLoggedInSponsor = loggedInUserInfo?.Role?.name === "SPONSOR";

  const locationOptions = [
    { value: "", label: "All Locations" },
    ...locations.map((loc) => ({
      value: loc.id,
      label: loc.name,
    })),
  ];

  useEffect(() => {
    if (!locations || locations.length === 0) {
      dispatch(getEventLocations());
    }
  }, [dispatch, locations.length]);

  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const role = user?.Role?.name;
  const allowedRoutes = rolePermissions[role] || [];
  const canAccess = (path) => {
    if (allowedRoutes.includes("*")) return true;
    return allowedRoutes.some((route) => path.startsWith(route));
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    navigate("/sign-in");
  };
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/dashboard' className='sidebar-logo'>
            <img
              src='/assets/images/logo.svg'
              alt='site logo'
              className='light-logo'
            />
            <img
              src='/assets/images/logo.svg'
              alt='site logo'
              className='dark-logo'
            />
            <img
              src='/assets/images/favicon.svg'
              alt='site logo'
              className='logo-icon'
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>
            {canAccess("/dashboard") && (
              <li className='dropdown'>
                <Link to='#'>
                  <Icon
                    icon='solar:home-smile-angle-outline'
                    className='menu-icon'
                  />
                  <span>Dashboard</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/dashboard'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Analytics
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Event Locations */}
            {canAccess("/event-locations") && (
              <li className='dropdown'>
                <Link to='#'>
                  <Icon
                    icon='fluent:location-24-regular'
                    className='menu-icon'
                  />
                  <span>Event Locations</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/event-locations'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Event Locations
                    </NavLink>
                  </li>

                </ul>
              </li>
            )}
            {/* Content */}
            {canAccess("/content") && (
              <li className='dropdown'>
                <Link to='#'>
                  <Icon
                    icon='solar:gallery-wide-bold'
                    className='menu-icon'
                  />
                  <span>Publishing</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/content'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Post Category
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/posts'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Posts
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {/* Sessions */}
            {canAccess("/sessions") && (
              <li className='dropdown'>
                <Link to='#'>
                  <Icon
                    icon='fluent:timer-24-regular'
                    className='menu-icon'
                  />
                  <span>Sessions</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/sessions-type'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Session Types
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/sessions'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Sessions
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {/* Users Dropdown */}
            {canAccess("/users") && (
              <li className='dropdown'>
                <Link to='#'>
                  <Icon
                    icon='flowbite:users-group-outline'
                    className='menu-icon'
                  />
                  <span>Users</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/users-list'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Users List
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/active-users'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Logged In Users
                    </NavLink>
                  </li>
                  {/* <li>
                  <NavLink
                    to='/users-grid'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    Users Grid
                  </NavLink>
                </li> */}
                  <li>
                    <NavLink
                      to='/add-user'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-info-main w-auto' />{" "}
                      Add User
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/ratings'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      User Ratings
                    </NavLink>
                  </li>
                  {/* <li>
                  <NavLink
                    to='/view-profile'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-danger-main w-auto' />{" "}
                    View Profile
                  </NavLink>
                </li> */}
                </ul>
              </li>
            )}
            {/* Role & Access Dropdown */}
            {canAccess("/roles") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i className='ri-user-settings-line' />
                  <span>Role &amp; Access</span>
                </Link>
                <ul className='sidebar-submenu'>
                  {canAccess("/role-access") && (
                    <li>
                      <NavLink
                        to='/role-access'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                        Role &amp; Access
                      </NavLink>
                    </li>
                  )}
                  {canAccess("/assign-role") && (
                    <li>
                      <NavLink
                        to='/assign-role'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                        Assign Role
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {/* Enquiry Dropdown */}
            {canAccess("/enquiry-list") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i className='ri-question-answer-line' />
                  <span>Enquiry</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/enquiry-list'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Guest Users
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {/* Networking  */}
            {canAccess("/meetings") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i className='ri-global-line' />
                  <span>Networking</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/meetings'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Meetings
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/chat-requests'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Chats
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/chat-conversations'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Conversations
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {/* Conference  */}
            {canAccess("/conference") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i className='ri-group-line' />
                  <span>Conference Agenda</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/conference-agenda'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Conference List
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {/* Floor Map  */}
            {canAccess("/floor-maps") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i className='ri-map-pin-line' />
                  <span>Floor Map</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/floor-maps'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Floor Map
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {/* Help Desk  */}
            {canAccess("/help-desk") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i className='ri-question-line' />
                  <span>Help Desk</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/help-desk'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Help Desk
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/support'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Support
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Media Center  */}
            {canAccess("/media") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i className='ri-music-line' />
                  <span>Media Center</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/media'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Media Center
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/gallery'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Gallery
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Ads Center  */}
            {canAccess("/add-management") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i class="ri-advertisement-line" />
                  <span>Ads Center</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/add-management'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Ads List
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Sponsored  */}
            {canAccess("/sponsors-list") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i className='ri-briefcase-line' />
                  <span>Sponsored</span>
                </Link>
                <ul className='sidebar-submenu'>
                  {canAccess("/company-category") && (
                    <li>
                      <NavLink
                        to='/company-category'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                        Company Category
                      </NavLink>
                    </li>
                  )}
                  {canAccess("/company-product") && (
                    <li>
                      <NavLink
                        to='/company-product'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                        Company Product
                      </NavLink>
                    </li>
                  )}
                  {canAccess("/sponsors") && (
                    <li>
                      <NavLink
                        to='/sponsors'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                        User List
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {/* Feedback  */}
            {canAccess("/feedback") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i class="ri-feedback-line"></i>
                  <span>Feedback</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/feedback'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Feedback
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/feedback-submissions'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Feedback Response
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Notification  */}
            {canAccess("/notifications") && (
              <li className='dropdown'>
                <Link to='#'>
                  <i className='ri-notification-2-line' />
                  <span>Notification</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/notifications'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      Notification
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {canAccess("/api-key-generate") && (
              <li className='dropdown'>
                <Link to='#'>
                  <Icon
                    icon='icon-park-outline:setting-two'
                    className='menu-icon'
                  />
                  <span>Settings</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/api-key-generate'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      API Key Generate
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {/* Masters  */}
            {/* <li className='dropdown'>
              <Link to='#'>
                <i className='ri-database-2-line' />
                <span>Masters</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/company-category'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    Company Category
                  </NavLink>
                </li>
              </ul>
            </li> */}


            {/* Settings Dropdown */}
            {/* <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='icon-park-outline:setting-two'
                  className='menu-icon'
                />
                <span>Settings</span>
              </Link>
              <ul className='sidebar-submenu'>
               
                <li>
                  <NavLink
                    to='/notification'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    Notification
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/notification-alert'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-info-main w-auto' />{" "}
                    Notification Alert
                  </NavLink>
                </li>
                
                <li>
                  <NavLink
                    to='/payment-gateway'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-danger-main w-auto' />{" "}
                    Payment Gateway
                  </NavLink>
                </li>
              </ul>
            </li> */}
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
                {!isLoggedInSponsor && (
                  <div style={{ width: 250 }}>
                    <Select
                      options={locationOptions}
                      value={selectedLocation}
                      onChange={setSelectedLocation}
                      placeholder="Filter by Location"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                {/* ThemeToggleButton */}
                {/* <ThemeToggleButton /> */}

                <HeaderMessageComponent />
                <HeaderNotificationComponent />
                <div className='dropdown'>

                  <div className="position-relative" ref={profileRef}>
                    <button
                      onClick={() => setProfileOpen((prev) => !prev)}
                      className="d-flex align-items-center gap-3 position-relative"
                    >

                      <Avatar
                        name={user?.fullName}
                        image={user?.profilePicture}
                        uniqueKey={user?.id}
                        size={40}
                      />
                    </button>

                    {profileOpen && (
                      <div className="dropdown-menu show to-top dropdown-menu-sm">
                        <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex justify-content-between">
                          <div>
                            <h6 className="text-lg fw-semibold mb-2">
                              {user?.fullName}
                            </h6>
                            <span className="text-sm">{user?.Role?.name}</span>
                          </div>
                          <button
                            onClick={() => setProfileOpen(false)}
                            className="border-0 bg-transparent"
                          >
                            <Icon icon="radix-icons:cross-1" />
                          </button>
                        </div>

                        <ul className="to-top-list">
                          <li>
                            <Link
                              to={`/view-profile/${user?.id}`}
                              className="dropdown-item d-flex align-items-center gap-3"
                            >
                              <Icon icon="solar:user-linear" />
                              My Profile
                            </Link>
                          </li>

                          <li>
                            <button
                              onClick={logout}
                              className="dropdown-item d-flex align-items-center gap-3 border-0 bg-transparent"
                            >
                              <Icon icon="lucide:power" />
                              Log Out
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>

        {/* Footer section */}
        {/* <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>© 2026 w.media. All Rights Reserved.</p>
            </div>
            <div className='col-auto'>
              <p className='mb-0'>
                Made by <span className='text-primary-600'><a href="https://theyellowstrawberry.com/" target="_blank">The Yellow Strawberry</a></span>
              </p>
            </div>
          </div>
        </footer> */}
      </main>
    </section>
  );
};

export default MasterLayout;
